import Orbit from "./Orbit";

// 패스 타입 정의
export interface Pass {
  satelliteName: string;
  StartTime: Date;
  MaxElevation: number;
  EndTime: Date;
  AvailableTime: number;
}

// 지상국 위치 좌표 타입 정의
export interface GroundStationPosition {
  longitude: number;
  latitude: number;
  height: number;
}

// ContactSchedule 클래스 정의
export class ContactSchedule {
  orbit: Orbit;
  passes: Pass[];
  satnum: any;

  constructor(tle: string, tags = []) {
    this.orbit = new Orbit(tle);
    this.satnum = this.orbit.satnum;
    this.passes = [];
  }

  // 패스 계산하기
  // updatePasses(satName: any, groundStationPosition: any, startDate: any, endDate: any, minElevation: any) {
  //   this.passes = this.orbit.computePassesElevation(
  //     satName, // 위성 이름
  //     groundStationPosition, // 지상국 좌표
  //     startDate, // 시작 시점
  //     endDate, // 종료 시점
  //     minElevation // 최소 고도 (= Mask Angle)
  //   );
  // }

    // 패스 계산하기
    updatePasses(satName: any, groundStationPosition: any, startDate: any, endDate: any) {
      this.passes = this.orbit.computePassesElevation(
        satName, // 위성 이름
        groundStationPosition, // 지상국 좌표
        startDate, // 시작 시점
        endDate, // 종료 시점
      );
    }
}